import { Component, OnInit, Injector } from '@angular/core';
import { WorkOrdersService } from '../../../work-orders.service';
import { FilterableService } from '../../../../filterable-service';
import {
  AuthorizationService,
  ProgramDetailsBodyService,
  PlantService, AreaService,
  ZoneService, GateService,
  TotalVehicleNumberService,
  MBOMService,
  TrackingVehicleNumberService
} from '../../../../ve.service';
import { AppService } from '../../../../../../app.service';
import { Validators } from '@angular/forms';

const PROGRAM_TRACKING_VEHICLE_NUMBER_TYPE = 'Body tracking vehicle by program.';
const TOTAL_NUMBER_TRACKING_VEHICLE_NUMBER_TYPE = 'Body tracking vehicle by total number.';
const TOTAL_VEHICLE_NUMBER = 'Total Vehicle Number';
const ACTIVE_ONLY_QUERY = '/?activeOnly=true';

@Component({
  selector: 'body-add-multiple-form',
  templateUrl: './body-add-multiple-form.component.html',
  styleUrls: [
    '../../../work-orders.component.scss',
    '../../../../../ve/ve.component.scss'
  ]
})
export class BodyAddMultipleFormComponent implements OnInit {
  workOrdersService: WorkOrdersService;
  bodyUserService: AuthorizationService;
  programDetailsService: ProgramDetailsBodyService;
  bodyPlantService: PlantService;
  bodyAreaService: AreaService;
  bodyZoneService: ZoneService;
  bodyGateService: GateService;
  bodyTotalVehicleNumberService: TotalVehicleNumberService;
  bodymBomService: MBOMService;
  bodyTrackingVehicleNumberService: TrackingVehicleNumberService;

  requestorService = new FilterableService();
  programService = new FilterableService();
  plantService = new FilterableService();
  areaService = new FilterableService();
  zoneService = new FilterableService();
  gateService = new FilterableService();
  totalVehicleNumberService = new FilterableService();
  mBomService = new FilterableService();
  trackingVehicleNumberService = new FilterableService();

  totalmBomSelectionList = [TOTAL_VEHICLE_NUMBER, 'mBom'];

  private readonly _fullScreenToggled: any;
  date: any;
  editForm: any;

  constructor(injector: Injector, private readonly appService: AppService) {
    this.workOrdersService = injector.get(WorkOrdersService);
    this.bodyUserService = injector.get(AuthorizationService);
    this.programDetailsService = injector.get(ProgramDetailsBodyService)
    this.bodyPlantService = injector.get(PlantService);
    this.bodyAreaService = injector.get(AreaService);
    this.bodyZoneService = injector.get(ZoneService);
    this.bodyGateService = injector.get(GateService);
    this.bodyTotalVehicleNumberService = injector.get(TotalVehicleNumberService);
    this.bodymBomService = injector.get(MBOMService);
    this.bodyTrackingVehicleNumberService = injector.get(TrackingVehicleNumberService);
    this.editForm = this.workOrdersService.bodyAddMultipleForm;
    this._fullScreenToggled = appService.fullScreenToggled.subscribe((isFullScreen) => {
      isFullScreen ? this.workOrdersService.groupcss = 'groupFullScreen' : this.workOrdersService.groupcss = 'group';
    });

  }

  ngOnInit() {
    this.appService.isFullScreen() ? this.workOrdersService.groupcss = 'groupFullScreen' : this.workOrdersService.groupcss = 'group';
    this.setRequestDate();

    Promise.all([
      this.getRequestors(),
      this.getPrograms(),
      this.getAreas(),
      this.getGates(),
    ]);
  }

  setRequestDate() {
    const date = new Date();
    this.editForm.get('RequestDate').setValue(date);
  }

  getRequestors(): Promise<any> {
    return this.bodyUserService.read('/moduleusers?moduleName=VE_Body')
      .then(result => {
        if (result.length > 0) {
          result.sort((a, b) => a.Name.localeCompare(b.Name));
        }
        this.requestorService.next(result);
      });
  }

  getPrograms(): Promise<any> {
    return this.programDetailsService.read(ACTIVE_ONLY_QUERY)
      .then(result => {
        if (result.length > 0) {
          result.sort((a, b) => a.ProgramCode.localeCompare(b.ProgramCode));
        }
        this.programService.next(result);
      });
  }

  getPlants(progamId): Promise<any> {
    return this.bodyPlantService.read(`ByProgram/${progamId}`)
      .then(plants => {
        if (plants.length > 0) {
          plants.sort((a, b) => a.PlantDescription.localeCompare(b.PlantDescription));
        }
        this.plantService.next(plants);
      });
  }

  getAreas(): Promise<any> {
    return this.bodyAreaService.read(ACTIVE_ONLY_QUERY)
      .then(result => {
        if (result.length > 0) {
          result.sort((a, b) => a.Description.localeCompare(b.Description));
        }
        this.areaService.next(result);
      });
  }

  getGates(): Promise<any> {
    return this.bodyGateService.read(ACTIVE_ONLY_QUERY)
      .then(result => {
        this.gateService.next(result);
      });
  }

  getmBoms(programId): Promise<any> {
    return this.bodymBomService.read(`/programid/${programId}${ACTIVE_ONLY_QUERY}`)
      .then(bodymBom => {
        if (bodymBom.length > 0) {
          bodymBom.sort((a, b) => a.Description.localeCompare(b.Description));
        }
        this.mBomService.next(bodymBom);
      });
  }

  getTrackingVehicleNumbers(searchId, searchType): Promise<any> {
    return this.trackingVehicleSearchServices[`${searchType}`](searchId)
      .then(trackingVehicleNumber => {
        if (trackingVehicleNumber.length > 0) {
          trackingVehicleNumber.sort((a, b) => a.Description.localeCompare(b.Description));
        }
        this.trackingVehicleNumberService.next(trackingVehicleNumber);
      });
  }

  getTotalVehicleNumbers(programId): Promise<any> {
    return this.bodyTotalVehicleNumberService.read(`/programid/${programId}`)
      .then(totalVehicleNumbers => {
        if (totalVehicleNumbers.length > 0) {
          totalVehicleNumbers.sort((a, b) => a.Description.localeCompare(b.Description));
        }
        this.totalVehicleNumberService.next(totalVehicleNumbers);
      });
  }

  getProgramRelatedFields(programId) {
    this.getmBoms(programId);
    this.getTrackingVehicleNumbers(programId, PROGRAM_TRACKING_VEHICLE_NUMBER_TYPE);
    if (this.isTotalVehicle()) {
      this.getTotalVehicleNumbers(programId);
    }
    this.setUserFields();
    this.getPlants(programId);
  }

  setUserFields() {
    const program = this.programService.value
      .filter(x => x.ProgramId === this.editForm.get('ProgramId').value);

    if (program.length > 0) {
      this.editForm.get('VELead').setValue(program[0].VELead);
      this.editForm.get('VELeadName').setValue(program[0].VELeadName);
      this.editForm.get('PIE').setValue(program[0].PIE);
      this.editForm.get('PIEName').setValue(program[0].PIEName);
      this.editForm.get('PLL').setValue(program[0].PLL);
      this.editForm.get('PLLName').setValue(program[0].PLLName);
      this.editForm.get('DispenseEngineer').setValue(program[0].DispenseEngineer);
      this.editForm.get('DispenseEngineerName').setValue(program[0].DispenseEngineerName);
      this.editForm.get('BiwManager').setValue(program[0].BiwManager);
      this.editForm.get('BiwManagerName').setValue(program[0].BiwManagerName);
      this.editForm.get('WeldEngineer').setValue(program[0].WeldEngineer);
      this.editForm.get('WeldEngineerName').setValue(program[0].WeldEngineerName);
    }
  }

  handleProgramChange = (programId: any) => {
    if (programId) {
      this.clearProgramRelatedFields();
      this.getProgramRelatedFields(programId);
    }
  }

  clearProgramRelatedFields() {
    const programFields = [
      'PlantId',
      'TrackingVehicleNumberId',
      'TotalVehicleNumberId',
      'MbomId',
      'VELead',
      'VELeadName',
      'PIE',
      'PIEName',
      'PLL',
      'PLLName',
      'BiwManager',
      'BiwManagerName',
      'WeldEngineer',
      'WeldEngineerName',
      'DispenseEngineer',
      'DispenseEngineerName'];

    programFields.forEach(element => {
      const formItem = this.editForm.get(element);
      if (formItem.value) {
        formItem.setValue(null);
      }
    });
  }

  handleTotalVehicleMbomChange = () => {
    const selectedValue = this.editForm.get('totalmBomSelected').value;

    if (selectedValue === TOTAL_VEHICLE_NUMBER) {
      this.editForm.get('TotalVehicleNumberId').setValidators([Validators.required]);
      this.editForm.get('TrackingVehicleNumberId').setValidators([Validators.required]);
      this.resetMbom();
    } else if (selectedValue === 'mBom') {
      this.editForm.get('MbomId').setValidators([Validators.required]);
      this.resetTotalVehicleNumber();
    } else {
      this.resetTotalVehicleNumber();
      this.resetMbom();
    }
  }

  handleTotalVehicleChange = (totalVehicleId, firstRender) => {
    const programId = this.editForm.get('ProgramId').value;

    if (!firstRender) {
      this.editForm.get('TrackingVehicleNumberId').setValue(null);
    }
    if (totalVehicleId) {
      this.getTrackingVehicleNumbers(totalVehicleId, TOTAL_NUMBER_TRACKING_VEHICLE_NUMBER_TYPE);
    } else if (programId && !totalVehicleId) {
      this.getTotalVehicleNumbers(programId);
      this.getTrackingVehicleNumbers(programId, PROGRAM_TRACKING_VEHICLE_NUMBER_TYPE);
    }
  }

  handleAreaChange = (areaId) => {
    if (areaId) {
      this.bodyZoneService.read(`ByArea/${areaId}`)
        .then(result => {
          if (result.length > 0) {
            result.sort((a, b) => a.Description.localeCompare(b.Description));
          }
          this.zoneService.next(result);
        });
    } else {
      this.editForm.get('ZoneId').setValue(null);
    }
  }

  resetTotalVehicleNumber() {
    this.editForm.get('TotalVehicleNumberId').setValidators(null);
    this.editForm.get('TotalVehicleNumberId').setErrors(null);
    this.editForm.get('TotalVehicleNumberId').setValue(null);
    this.editForm.get('TrackingVehicleNumberId').setValidators(null);
    this.editForm.get('TrackingVehicleNumberId').setErrors(null);
    this.editForm.get('TrackingVehicleNumberId').setValue(null);
  }

  resetMbom() {
    this.editForm.get('MbomId').setValidators(null);
    this.editForm.get('MbomId').setErrors(null);
    this.editForm.get('MbomId').setValue(null);
    this.editForm.get('TrackingVehicleNumberId').setValue(null);
    const programId = this.editForm.get('ProgramId').value;
    if (programId) {
      this.getTrackingVehicleNumbers(programId, PROGRAM_TRACKING_VEHICLE_NUMBER_TYPE);
      this.getTotalVehicleNumbers(programId);
    } else {
      this.trackingVehicleNumberService.next(null);
    }
  }

  isTotalVehicle = () => {
    return this.editForm.get('totalmBomSelected').value === TOTAL_VEHICLE_NUMBER;
  }

  /**
 * Service object function mapper for common search endpoints between GA and Body.
 *
 * @readonly
 * @memberof WorkOrderScheduleEditService
 */
  get trackingVehicleSearchServices() {
    return {
      [`${PROGRAM_TRACKING_VEHICLE_NUMBER_TYPE}`]: (programId) => this.bodyTrackingVehicleNumberService.read(`/programid/${programId}`),
      [`${TOTAL_NUMBER_TRACKING_VEHICLE_NUMBER_TYPE}`]: (totalVehicleNumber) => this.bodyTrackingVehicleNumberService.read(`/totalvehiclenumberid/${totalVehicleNumber}`),
    };
  }
}
